import type { AppAbility } from './types'

import { createContextualCan } from '@casl/react'
import { createContext } from 'react'

// @ts-expect-error default value for ability can be undefined
export const AbilityContext = createContext<AppAbility>(undefined)
export const Can = createContextualCan(AbilityContext.Consumer)
